import toast from './toast';

export enum ToastType {
  Green = 'Green',
  Red = 'Red'
}

export interface ToastItem {
  type: ToastType;
  message: string;
  createdOn: Date;
}

export const pushAppLevelToast = (notifications: ToastItem[]) => {
  notifications.forEach(n => {
    if (n.type === ToastType.Green) {
      toast.success(n.message, {
        createdOn: n.createdOn,
        duration: 30,
        closable: true
      });
    } else if (n.type === ToastType.Red) {
      toast.error(n.message, {
        createdOn: n.createdOn,
        duration: null,
        closable: true
      });
    }
  });
};

export const removeOtherToast = () => {
  toast.removeOthers();
}
